'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgFileAddFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M14 8V2H4v20h16V8h-6Zm2 7h-3v3h-2v-3H8v-2h3v-3h2v3h3v2Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M15.5 2.09V6.5h4.41L15.5 2.09Z" })
);

module.exports = SvgFileAddFill;
//# sourceMappingURL=FileAddFill.cjs.js.map
